import type { FaireProductEntity } from "../../entity_types/product";

export const p_3x7jurawxd: FaireProductEntity = {
  token: "p_3x7jurawxd",
  type: "product",
  name: "Houndstooth Tailored Blazer Jacket",
  brandToken: "b_nd6psatxbw",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/f87b48be582ce4d1c3072c40ce25f8636918b0293dcd1b9bc9aa38a9f43c6d80.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3d0bdb7d12664d886d59416b267eede6ee20dfe06ba01bad84f8b321632fed08.jpeg",
    "https://cdn.faire.com/fastly/34b41e36a9235739df9902b55fe6775e9a9dc7c436bf45bfeec8ec6d70cc248d.jpeg",
    "https://cdn.faire.com/fastly/dd75e43cc5a48453bb5b6221cb958091f16bc56e5f2582a7f0d23ea5ea1430c6.png",
  ],
  priceDollars: 38.11,
  description:
    "This tailored blazer features a timeless houndstooth pattern with a structured yet relaxed silhouette. Designed for effortless elegance, it offers a polished look suitable for office wear, boutique collections, and smart-casual styling. The clean lines and refined texture make it a versatile layering piece for transitional seasons.\n\nMaterial: Polyester\nWeight: 0.53 kg\n",
  tags: [],
  msrpDollars: 76.21,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:20.935Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
